import { render, staticRenderFns } from "./SimpleCard.vue?vue&type=template&id=2fc7fc24&scoped=true&"
import script from "./SimpleCard.vue?vue&type=script&lang=js&"
export * from "./SimpleCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCard.vue?vue&type=style&index=0&id=2fc7fc24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7fc24",
  null
  
)

export default component.exports